import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

const styles = createStyles({
  ul: {
    marginBottom: '40px',
  },
});

const MarkdownUlInternal: React.FC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => <ul className={classes.ul}>{children}</ul>;

const MarkdownUl = withStyles(styles)(MarkdownUlInternal);
export { MarkdownUl };
